import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const updatedByColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'modifiedByUserName',
  headerName: 'Updated By',
};
